let unshaken = true;

function getContainer() {

    return document.querySelector('.js_oraComparisonCards__slider');
}

function countCards() {
    const container = getContainer();
    let count = 0;

    if (container) {
        count = [...container.querySelectorAll('.js_oraOfferCard')].length; 
    }

    return count;
}

function shouldShake(entries) {

    return entries[0].isIntersecting && window.innerWidth < 430 && unshaken;
}

function maybeShake(entries, observer) {
    if (shouldShake(entries)) {
        const container = getContainer();

        if (container) {
            shake(container);
        }
    }
}

function shake(container) {
    container.classList.add('oraComparisonCards__slider--shake');
    unshaken = false;
}

function init() {
    const container = getContainer(),
          cardCount = countCards();
    
    if (container && cardCount > 1) {
        const options = {
            root: null,
            threshold:0.4,
            rootMargin:'0px',
        };

        const observer = new IntersectionObserver(maybeShake, options);
        observer.observe(container);
    }
}

$(document).ready(init);
